import type { Moment } from 'moment'
import type { ComponentProps } from 'react'
import { useCallback, useContext } from 'react'
import { useIntl } from 'react-intl'

import TextButton from 'LuxKit/Button/TextButton'
import ModalContext from 'contexts/ModalContext'

interface Props {
  offerId?: string
  checkIn?: Moment
  checkOut?: Moment
  tripId: string
  sectionId: string
  className?: string
  showSearch: boolean
  size?: ComponentProps<typeof TextButton>['size']
}

function ViewMoreOffersCta({
  offerId,
  checkIn,
  checkOut,
  sectionId,
  tripId,
  className,
  showSearch,
  size = 'medium',
}: Props) {
  const intl = useIntl()
  const showModal = useContext(ModalContext)

  const handleClick = useCallback(async(e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()
    const { default: MoreOffersModal } = await import('tripPlanner/components/TripModal/ViewMoreOffers/MoreOffersModal')
    showModal(
      <MoreOffersModal
        tripId={tripId}
        sectionId={sectionId}
        offerId={offerId}
        checkIn={checkIn}
        checkOut={checkOut}
        showSearch={showSearch}
      />,
    )
  }, [checkIn, checkOut, offerId, sectionId, showModal, showSearch, tripId])

  return (
    <TextButton
      kind="secondary"
      size={size}
      className={className}
      onClick={handleClick}
    >
      {intl.formatMessage({
        id: '5Zj0d-7dPFwoanmfQ_FE',
        defaultMessage: 'View more offers',
        description: 'Button to view additional accommodation offers for a trip item',
      })}
    </TextButton>
  )
}

export default ViewMoreOffersCta
